import { useEffect, useRef } from 'react';
import { atom, useAtom, useAtomValue } from 'jotai';
import { createApiClient } from '../api/client';
import { USER_API_PATHS } from '../constants/api';

// Each federation will load its instance - so no harm
const customerUsersState = atom({
  /* [customerId]: { users: [], activeUsers: [] } */
  loading: false
});

export const useCustomerUsers = ({ customerId }) => {
  const [state, setCustomerUsers] = useAtom(customerUsersState);
  const loadingRef = useRef({});

  const fetchCustomerUsers = async () => {
    if (!customerId || loadingRef.current[customerId] || state[customerId]?.users?.length) return;

    loadingRef.current[customerId] = true;
    setCustomerUsers(prev => ({ ...prev, loading: true }));
    try {
      const { data } = await createApiClient().post(USER_API_PATHS.LIST, { customer_id: [customerId] });
      const userData = data?.response?.user || [];
      const activeUsers = userData.filter(u => u.status === 'active');

      setCustomerUsers(prev => ({ ...prev, [customerId]: { users: userData, activeUsers }, loading: false }));
    } catch (e) {
      setCustomerUsers(prev => ({ ...prev, [customerId]: { users: [], activeUsers: [] }, loading: false }));
    }
    loadingRef.current[customerId] = false;
  };

  useEffect(() => {
    fetchCustomerUsers();
  }, [customerId]);
};

export const useCustomerUsersState = ({ customerId }) => {
  const customerUsers = useAtomValue(customerUsersState);
  const { users = [], activeUsers = [] } = customerUsers[customerId] || {};

  return { loading: customerUsers.loading, users, activeUsers };
};
